// Override Settings
var bcSfFilterSettings = {
    general: {
        limit: bcSfFilterConfig.custom.products_per_page,
        // Optional
        loadProductFirst: true,
        // paginationType: 'load_more'
    },
};

var bcSfFilterTemplate = {
    // Grid Template
    'vendorGridHtml': '<div class="grid-view-item__vendor">{{itemVendorLabel}}</div>',

    'productGridItemHtml': '<div class="collectionBlock collectionBlock--remargined js-collectionBlock block s1 sm_s12 lg_s1' +  bcSfFilterConfig.custom.columnsSize + ' {{itemGridWidthClass}} {{lastElementClass}}" data-animation="fadeInUp">' +
    '<a aria-label="{{itemTitle}}" href="{{itemUrl}}" title="{{itemTitle}}" class="collectionBlock-image '+ bcSfFilterConfig.custom.image_size_class + ' lazyload fade-in {{itemSecondImageClass}}" data-bgset="{{itemBgSet}}" data-sizes="auto" data-parent-fit="cover" data-aspectratio="{{itemRatio}}">' +
    '{{itemHoverImages}}' +
    '{{itemStatus}}' +
    '{{itemQuickView}}'+
    '{{itemOnlineExclusive}}' +
    '</a>' +
    '<div class="collectionBlock-info">'+
    '<a tabindex="-1" href="{{itemUrl}}"><h4>{{itemTitle}}</h4></a>' +
    '{{itemPrice}}'+
    '<span class="variant-sku">{{itemSKU}}</span>' +
    '<div class="swatches-fake">' +
    '{{itemSwatches}}' +
    '</div>' +
    '</div>'+
    '{{itemReviews}}' +
    '<script class="product-json" type="application/json">{{itemJson}}</script>' +
    '</div>',

    // Pagination Template
    'previousActiveHtml': '<li><a href="{{itemUrl}}">&larr;</a></li>',
    'previousDisabledHtml': '<li class="disabled"><span>&larr;</span></li>',
    'nextActiveHtml': '<li><a href="{{itemUrl}}">&rarr;</a></li>',
    'nextDisabledHtml': '<li class="disabled"><span>&rarr;</span></li>',
    'pageItemHtml': '<li><a href="{{itemUrl}}">{{itemTitle}}</a></li>',
    'pageItemSelectedHtml': '<li><span class="active">{{itemTitle}}</span></li>',
    'pageItemRemainHtml': '<li><span>{{itemTitle}}</span></li>',
    'paginateHtml': '<div class="pagination"><ul class="pagination-custom">{{previous}}{{pageItems}}{{next}}</ul></div>',

    // Sorting Template
    'sortingHtml': '<label class="label--hidden">' + bcSfFilterConfig.label.sorting + '</label><select class="filters-toolbar__input filters-toolbar__input--sort">{{sortingItems}}</select>',
};

BCSfFilter.prototype.buildProductGridItem = function (data, index) {
    /*** Prepare data ***/
    var images = data.images_info;
    // Displaying price base on the policy of Shopify, have to multiple by 100
    var soldOut = !data.available; // Check a product is out of stock
    var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
    var priceVaries = data.price_min != data.price_max; // Check a product has many prices
    // Get First Variant (selected_or_first_available_variant)
    var firstVariant = data['variants'][0];
    if (getParam('variant') !== null && getParam('variant') != '') {
        var paramVariant = data.variants.filter(function (e) {
            return e.id == getParam('variant');
        });
        if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
    } else {
        for (var i = 0; i < data['variants'].length; i++) {
            if (data['variants'][i].available) {
                firstVariant = data['variants'][i];
                break;
            }
        }
    }
    /*** End Prepare data ***/

        // Get Template
    var itemHtml = bcSfFilterTemplate.productGridItemHtml;

    // Build Special Class
    var itemGridWidthClass = '';
    if (bcSfFilterConfig.custom.transition_grid_items) {
        itemGridWidthClass += ' will-animate';
    }
    if (index == 1) {
        itemGridWidthClass += ' is-visible';
    }
    itemHtml = itemHtml.replace(/{{itemGridWidthClass}}/g, itemGridWidthClass);

    var lastElementClass = '';
    if (bcSfFilterConfig.custom.featured == 'image') {
        if (bcSfFilterConfig.custom.productsColumns == 2 || bcSfFilterConfig.custom.productsColumns == 3) {
            if (index == bcSfFilterConfig.custom.products_per_page) {
                lastElementClass = 'visually-hidden';
            }
        }
    } else if (bcSfFilterConfig.custom.featured == 'product') {
        if (bcSfFilterConfig.custom.productsColumns == 3) {
            if (index == bcSfFilterConfig.custom.products_per_page) {
                lastElementClass = 'visually-hidden';
            }
        }
    }
    itemHtml = itemHtml.replace(/{{lastElementClass}}/g, lastElementClass);

    var itemRatio = '';
    itemRatio = images.length > 0 ? (images[0]['width'] / images[0]['height']) : '1.0';
    itemHtml = itemHtml.replace(/{{itemRatio}}/g, itemRatio);

    // Add the second image class
    var itemSecondImageClass = '';
    if (data.images[1] && bcSfFilterConfig.custom.hover_image) {
        itemSecondImageClass = 'has-second-image';
    }
    itemHtml = itemHtml.replace(/{{itemSecondImageClass}}/g, itemSecondImageClass);

    // Build Bgset
    var thumb = images.length > 0 ? images[0] : bcSfFilterConfig.general.no_image_url;
    var bgset = buildBgSet(thumb);
    itemHtml = itemHtml.replace(/{{itemBgSet}}/g, bgset);

    // Build Item Hover Images
    var itemHoverImagesHtml = '';
    if (images.length > 1 && images[1]['src'] != '' && bcSfFilterConfig.custom.hover_image) {
        itemHoverImagesHtml += '<div class="collectionBlock-hover">';
        itemHoverImagesHtml += '<span class="collectionBlock-hover lazyload fade-in" data-bgset="' + buildBgSet(images[1]) + '" data-sizes="auto"></span>';
        itemHoverImagesHtml += '</div>';
    }
    itemHtml = itemHtml.replace(/{{itemHoverImages}}/g, itemHoverImagesHtml);

    // Build Item Status
    var itemStatusHtml = '';
    if (onSale || soldOut) {
        itemStatusHtml += '<span class="product-status-flag' + (soldOut ? ' is-sold-out' : '') + (onSale ? ' is-sale' : '') + '">';
        if (onSale) {
            itemStatusHtml += bcSfFilterConfig.label.on_sale;
        } else {
            itemStatusHtml += bcSfFilterConfig.label.sold_out;
        }
        itemStatusHtml += '</span>';
    }
    itemHtml = itemHtml.replace(/{{itemStatus}}/g, itemStatusHtml);

    // Build Item QuickView
    var itemQuickView = '';
    if (bcSfFilterConfig.custom.show_quick_view) {
        var featured_image = data.featured_image;
        itemQuickView += '<div class="collectionBlock-image-inner">' +
            '<div data-handle="{{itemHandle}}" class="js-quickView quickView-button button">' + bcSfFilterConfig.custom.grid_quick_view + '</div>' +
            '<div class="quickview-product-images" data-handle="{{itemHandle}}" style="display: none">' +
            '<div class="quickview-product-image quickView-variant-img--is-active lazyload fade-in" data-bgset="' + bgset + '" data-image="'+ featured_image.src +'" data-sizes="auto" data-parent-fit="contain"></div>';

        var images = data.images;

        // images.forEach((image) => {
        //     if (image != featured_image) {
        //         itemQuickView += '<div class="quickview-product-image lazyload fade-in" data-bgset="' + buildBgSet(image) + '" data-image="'+ image.src +'" data-sizes="auto" data-parent-fit="contain"></div>';
        //     }
        // });

        for (var i = 0; i < images.length; i++) {

            if (images[i] != featured_image) {
                itemQuickView += '<div class="quickview-product-image lazyload fade-in" data-bgset="' + buildBgSet(images[i]) + '" data-image="'+ images[i].src +'" data-sizes="auto" data-parent-fit="contain"></div>';
            }

        }

        itemQuickView += '</div>';
        itemQuickView += '</div>';
    }
    itemHtml = itemHtml.replace(/{{itemQuickView}}/g, itemQuickView);

    // Add Price
    var itemPriceHtml = buildPrice(data, onSale, priceVaries);
    itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

    // Add SKU
    itemHtml = itemHtml.replace(/{{itemSKU}}/g, data.skus[0]);
    //console.log(data);

    // Online Exclusive?
    var exclusive = this.getProductMetafield(data , 'product_exclusive' , 'visible');
    if(exclusive == 'true'){
        itemHtml = itemHtml.replace(/{{itemOnlineExclusive}}/g,'<div class="exclusive-message exclusive-message--collection"><h5 class="h6">Online exclusive</h5></div>');
    } else {
        itemHtml = itemHtml.replace(/{{itemOnlineExclusive}}/g, '');
    }




    // Build Item Swatches
    var itemSwatchesHtml = buildSwatch(data);
    itemHtml = itemHtml.replace(/{{itemSwatches}}/g, itemSwatchesHtml);

    // Build Item Swatches
    var itemReviewsHtml = '';
    if (bcSfFilterConfig.custom.show_reviews) {
        itemReviewsHtml += '<div class="reviews-fake">';
        itemReviewsHtml += '<span class="shopify-product-reviews-badge" data-id="{{itemId}}"></span>';
        itemReviewsHtml += '</div>';
    }
    itemHtml = itemHtml.replace(/{{itemReviews}}/g, itemReviewsHtml);

    // Add main attribute
    itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
    itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
    itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
    itemHtml = itemHtml.replace(/{{itemHandle}}/g, data.handle);
    itemHtml = itemHtml.replace(/{{itemUrl}}/g, this.buildProductItemUrl(data));

    return itemHtml;
}

function buildBgSet(image) {
    var html = '';
    if (typeof image !== 'undefined' && image.hasOwnProperty('src')) {
        var aspectRatio = image.width / image.height;
        if (image.width > 180) html += bcsffilter.optimizeImage(image['src'], '180x') + ' 180w ' + Math.round(180 / aspectRatio) + 'h,';
        if (image.width > 360) html += bcsffilter.optimizeImage(image['src'], '360x') + ' 360w ' + Math.round(360 / aspectRatio) + 'h,';
        if (image.width > 540) html += bcsffilter.optimizeImage(image['src'], '540x') + ' 540w ' + Math.round(540 / aspectRatio) + 'h,';
        if (image.width > 720) html += bcsffilter.optimizeImage(image['src'], '720x') + ' 720w ' + Math.round(720 / aspectRatio) + 'h,';
        if (image.width > 900) html += bcsffilter.optimizeImage(image['src'], '900x') + ' 900w ' + Math.round(900 / aspectRatio) + 'h,';
        if (image.width > 1080) html += bcsffilter.optimizeImage(image['src'], '1080x') + ' 1080w ' + Math.round(1080 / aspectRatio) + 'h,';
        if (image.width > 1296) html += bcsffilter.optimizeImage(image['src'], '1296x') + ' 1296w ' + Math.round(1296 / aspectRatio) + 'h,';
        if (image.width > 1512) html += bcsffilter.optimizeImage(image['src'], '1512x') + ' 1512w ' + Math.round(1512 / aspectRatio) + 'h,';
        if (image.width > 1728) html += bcsffilter.optimizeImage(image['src'], '1728x') + ' 1728w ' + Math.round(1728 / aspectRatio) + 'h,';
        if (image.width > 1950) html += bcsffilter.optimizeImage(image['src'], '1950x') + ' 1950w ' + Math.round(1950 / aspectRatio) + 'h,';
        if (image.width > 2100) html += bcsffilter.optimizeImage(image['src'], '2100x') + ' 2100w ' + Math.round(2100 / aspectRatio) + 'h,';
        if (image.width > 2260) html += bcsffilter.optimizeImage(image['src'], '2260x') + ' 2260w ' + Math.round(2260 / aspectRatio) + 'h,';
        if (image.width > 2450) html += bcsffilter.optimizeImage(image['src'], '2450x') + ' 2450w ' + Math.round(2450 / aspectRatio) + 'h,';
        if (image.width > 2700) html += bcsffilter.optimizeImage(image['src'], '2700x') + ' 2700w ' + Math.round(2700 / aspectRatio) + 'h,';
        if (image.width > 3000) html += bcsffilter.optimizeImage(image['src'], '3000x') + ' 3000w ' + Math.round(3000 / aspectRatio) + 'h,';
        if (image.width > 3350) html += bcsffilter.optimizeImage(image['src'], '3350x') + ' 3350w ' + Math.round(3350 / aspectRatio) + 'h,';
        if (image.width > 3750) html += bcsffilter.optimizeImage(image['src'], '3750x') + ' 3750w ' + Math.round(3750 / aspectRatio) + 'h,';
        if (image.width > 4100) html += bcsffilter.optimizeImage(image['src'], '4100x') + ' 4100w ' + Math.round(4100 / aspectRatio) + 'h,';
        html += bcsffilter.optimizeImage(image['src']) + ' ' + image.width + 'w ' + image.height + 'h,';
    }
    return html;
}

function buildPrice(data, onSale, priceVaries) {
    var priceHtml = '';
    var cpbProductSelector = data.product_type === 'cpb_product' || data.product_type === 'cpb_ordered' || data.product_type === 'cpb_hybrid'
    if (priceVaries) {
        priceHtml += '<p class="price {{cpbProductSelector}} {{hover}}">'+ bcSfFilterConfig.label.from + ' ' + bcsffilter.formatMoney(data.price_min, bcsffilter.moneyFormat) + '</p>';
    } else {
        if (onSale) {
            priceHtml += '<p class="price sale {{cpbProductSelector}} {{hover}}"><strike>' + bcsffilter.formatMoney(data.compare_at_price_min, bcsffilter.moneyFormat) + '</strike>' + bcsffilter.formatMoney(data.price_min, bcsffilter.moneyFormat) + '</p>';
        } else {
            priceHtml += '<p class="price {{cpbProductSelector}} {{hover}}">' + bcsffilter.formatMoney(data.price_min, bcsffilter.moneyFormat) + '</p>';
        }
    }
    priceHtml = priceHtml.replace(/{{hover}}/g, bcSfFilterConfig.custom.price_hover ? 'price--hover' : '');
    priceHtml = priceHtml.replace(/{{cpbProductSelector}}/g, cpbProductSelector ? 'cpb_product' : '');
    return priceHtml;
}

function buildSwatch(data){
    var html = '';
    var swatchItems = [];
    var colorOptionIndex = 0;
    if (bcSfFilterConfig.custom.color_swatches){
        var colorKeys = ['color', 'colors', 'colour' ,'colours'];
        var colorValues = [];
        data.variants.forEach(function(variant){
            var colorValue = null;
            variant.merged_options.forEach(function(merged_option, optionIndex){
                var key = merged_option.split(':')[0];
                var value = merged_option.split(':')[1];
                if (colorKeys.indexOf(key.toLowerCase().trim()) != -1 && colorValues.indexOf(value.toLowerCase().trim()) == -1){
                    colorValue = value;
                    colorValues.push(value.toLowerCase().trim());
                    colorOptionIndex = optionIndex;
                }
            })
            if (colorValue){
                var swatchItem ='<div data-value="{{colorValue}}" class="swatch-element color {{slugifyColor}} {{available}}">' +
                    '<label title="Brown">' +
                    '<input id="product_id-{{itemId}}-swatch-{{colorOptionIndex}}-{{slugifyColor}}" type="radio" name="product_id-{{itemId}}-swatch-{{colorOptionIndex}}" value="{{colorValue}}">' +
                    '<span style="background-color: {{backgroundColor}}; background-image: url({{backgroundImage}})"></span>' +
                    '</label>' +
                    '<a href="{{variantUrl}}" class="swatch-link">{{slugifyColor}}</a>' +
                    '</div>';

                var variantImage = variant.image ? variant.image : (data.images_info.length > 0 ? data.images_info[0].src : bcSfFilterMainConfig.general.no_image_url);
                swatchItem = swatchItem.replace(/{{variantImage}}/g, bcsffilter.optimizeImage(variantImage, 'large'));
                swatchItem = swatchItem.replace(/{{variantUrl}}/g, '{{itemUrl}}?variant=' + variant.id);
                swatchItem = swatchItem.replace(/{{colorValue}}/g, colorValue);
                swatchItem = swatchItem.replace(/{{available}}/g, variant.available ? 'available' : 'soldout');

                var slugifyColor = bcsffilter.slugify(colorValue);
                swatchItem = swatchItem.replace(/{{slugifyColor}}/g, slugifyColor);
                swatchItem = swatchItem.replace(/{{backgroundColor}}/g, slugifyColor.split('-').pop());

                var backgroundImage = bcSfFilterMainConfig.general.asset_url.split('bc-sf-filter.js')[0] + slugifyColor + '.png';
                swatchItem = swatchItem.replace(/{{backgroundImage}}/g, backgroundImage);
                swatchItems.push(swatchItem);
            }
        });
        if (swatchItems.length > 0){
            html = '<div class="swatch swatch--' + bcSfFilterConfig.custom.color_swatches_style + ' clearfix" data-option-index="' + colorOptionIndex + '">' + swatchItems.join(' ') +'</div>';
        }
    }
    return html;
}

// Build Pagination
BCSfFilter.prototype.buildPagination = function(totalProduct) {
    if (this.getSettingValue('general.paginationType') == 'default') {
        // Get page info
        var currentPage = parseInt(this.queryParams.page);
        var totalPage = Math.ceil(totalProduct / this.queryParams.limit);

        // If it has only one page, clear Pagination
        if (totalPage == 1) {
            jQ(this.selector.bottomPagination).html('');
            return false;
        }

        if (this.getSettingValue('general.paginationType') == 'default') {
            var paginationHtml = bcSfFilterTemplate.paginateHtml;

            // Build Previous
            var previousHtml = (currentPage > 1) ? bcSfFilterTemplate.previousActiveHtml : bcSfFilterTemplate.previousDisabledHtml;
            previousHtml = previousHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage - 1));
            paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

            // Build Next
            var nextHtml = (currentPage < totalPage) ? bcSfFilterTemplate.nextActiveHtml :  bcSfFilterTemplate.nextDisabledHtml;
            nextHtml = nextHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, currentPage + 1));
            paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

            // Create page items array
            var beforeCurrentPageArr = [];
            for (var iBefore = currentPage - 1; iBefore > currentPage - 3 && iBefore > 0; iBefore--) {
                beforeCurrentPageArr.unshift(iBefore);
            }
            if (currentPage - 4 > 0) {
                beforeCurrentPageArr.unshift('...');
            }
            if (currentPage - 4 >= 0) {
                beforeCurrentPageArr.unshift(1);
            }
            beforeCurrentPageArr.push(currentPage);

            var afterCurrentPageArr = [];
            for (var iAfter = currentPage + 1; iAfter < currentPage + 3 && iAfter <= totalPage; iAfter++) {
                afterCurrentPageArr.push(iAfter);
            }
            if (currentPage + 3 < totalPage) {
                afterCurrentPageArr.push('...');
            }
            if (currentPage + 3 <= totalPage) {
                afterCurrentPageArr.push(totalPage);
            }

            // Build page items
            var pageItemsHtml = '';
            var pageArr = beforeCurrentPageArr.concat(afterCurrentPageArr);
            for (var iPage = 0; iPage < pageArr.length; iPage++) {
                if (pageArr[iPage] == '...') {
                    pageItemsHtml += bcSfFilterTemplate.pageItemRemainHtml;
                } else {
                    pageItemsHtml += (pageArr[iPage] == currentPage) ? bcSfFilterTemplate.pageItemSelectedHtml : bcSfFilterTemplate.pageItemHtml;
                }
                pageItemsHtml = pageItemsHtml.replace(/{{itemTitle}}/g, pageArr[iPage]);
                pageItemsHtml = pageItemsHtml.replace(/{{itemUrl}}/g, this.buildToolbarLink('page', currentPage, pageArr[iPage]));
            }
            paginationHtml = paginationHtml.replace(/{{pageItems}}/g, pageItemsHtml);

            jQ(this.selector.bottomPagination).html(paginationHtml);
        }
    }
};

// Build Sorting
BCSfFilter.prototype.buildFilterSorting = function () {
    if (bcSfFilterTemplate.hasOwnProperty('sortingHtml')) {
        jQ(this.selector.topSorting).html('');

        var sortingArr = this.getSortingList();
        if (sortingArr) {
            // Build content
            var sortingItemsHtml = '';
            for (var k in sortingArr) {
                sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
            }
            var html = bcSfFilterTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
            jQ(this.selector.topSorting).html(html);

            // Set current value
            jQ(this.selector.topSorting + ' select').val(this.queryParams.sort);
        }
    }
};

// Add additional feature for product list, used commonly in customizing product list
BCSfFilter.prototype.buildExtrasProductList = function (data, eventType) {
    var self = this;

    // re-call theme function
    Site.animations.animateAll();

    // build quickview html
    var bcProductsSelector = jQ(self.selector.products);
    bcProductsSelector.find('a.collectionBlock-image').each(function (e) {
        var _this = this;
        jQ.ajax({
            type: "GET",
            crossDomain: true,
            url: jQ(_this).attr("href") + '?view=bc-sf-filter-modular-product-json',
            success: function (ajaxData) {
                jQ(_this).siblings('.product-json').html(ajaxData);
            }
        });
    });
};

// Build Additional Elements
BCSfFilter.prototype.buildAdditionalElements = function (data, eventType) {
    var totalProduct = '';
    if (data.total_product == 1) {
        totalProduct = bcSfFilterConfig.label.items_with_count_one.replace(/{{ count }}/g, data.total_product);
    } else {
        totalProduct = bcSfFilterConfig.label.items_with_count_other.replace(/{{ count }}/g, data.total_product);
    }
    var totalProductSelector = jQ('#bc-sf-filter-total-product');
    totalProductSelector.html(totalProduct);

    var shopCurrency = bcSfFilterConfig.shop.currency;
    var defaultCurrency = bcSfFilterConfig.shop.default_currency;
    var cookieCurrency = Currency.cookie.read();

    if (cookieCurrency == null) {
        if (shopCurrency !== defaultCurrency) {
            Currency.convertAll(shopCurrency, defaultCurrency);
        } else {
            Currency.currentCurrency = defaultCurrency;
        }
    }
    // If the cookie value does not correspond to any value in the currency dropdown.
    else if (jQ('[name=currencies]').length && jQ('[name=currencies] option[value=' + cookieCurrency + ']').length === 0) {
        Currency.currentCurrency = shopCurrency;
        Currency.cookie.write(shopCurrency);
    }
    else if (cookieCurrency === shopCurrency) {
        Currency.currentCurrency = shopCurrency;
    } else {
        Currency.convertAll(shopCurrency, cookieCurrency);
    }

    //Remove spacer div when using featured 2 products
    jQ('.js-collectionGrid .gridSpacer').remove();

    //Custom Edits to display custom No Search Results content
    if (data.total_product == 0) {
        jQ('#no-result').show();
        jQ('#no-result-collection').show();
        jQ('#no-result-count').hide();
    }
};

// Build Default layout
BCSfFilter.prototype.buildDefaultElements=function(){var isiOS=/iPad|iPhone|iPod/.test(navigator.userAgent)&&!window.MSStream,isSafari=/Safari/.test(navigator.userAgent),isBackButton=window.performance&&window.performance.navigation&&2==window.performance.navigation.type;if(!(isiOS&&isSafari&&isBackButton)){var self=this,url=window.location.href.split("?")[0],searchQuery=self.isSearchPage()&&self.queryParams.hasOwnProperty("q")?"&q="+self.queryParams.q:"";window.location.replace(url+"?view=bc-original"+searchQuery)}};

function customizeJsonProductData(data) {for (var i = 0; i < data.variants.length; i++) {var variant = data.variants[i];var featureImage = data.images.filter(function(e) {return e.src == variant.image;});if (featureImage.length > 0) {variant.featured_image = {"id": featureImage[0]['id'],"product_id": data.id,"position": featureImage[0]['position'],"created_at": "","updated_at": "","alt": null,"width": featureImage[0]['width'], "height": featureImage[0]['height'], "src": featureImage[0]['src'], "variant_ids": [variant.id]}} else {variant.featured_image = '';};};var self = bcsffilter;var itemJson = {"id": data.id,"title": data.title,"handle": data.handle,"vendor": data.vendor,"variants": data.variants,"url": self.buildProductItemUrl(data),"options_with_values": data.options_with_values,"images": data.images,"images_info": data.images_info,"available": data.available,"price_min": data.price_min,"price_max": data.price_max,"compare_at_price_min": data.compare_at_price_min,"compare_at_price_max": data.compare_at_price_max};return itemJson;};
BCSfFilter.prototype.prepareProductData = function(data) {var countData = data.length;for (var k = 0; k < countData; k++) {data[k]['images'] = data[k]['images_info'];if (data[k]['images'].length > 0) {data[k]['featured_image'] = data[k]['images'][0]} else {data[k]['featured_image'] = {src: bcSfFilterConfig.general.no_image_url,width: '',height: '',aspect_ratio: 0}}data[k]['url'] = '/products/' + data[k].handle;var optionsArr = [];var countOptionsWithValues = data[k]['options_with_values'].length;for (var i = 0; i < countOptionsWithValues; i++) {optionsArr.push(data[k]['options_with_values'][i]['name'])}data[k]['options'] = optionsArr;if (typeof bcSfFilterConfig.general.currencies != 'undefined' && bcSfFilterConfig.general.currencies.length > 1) {var currentCurrency = bcSfFilterConfig.general.current_currency.toLowerCase().trim();function updateMultiCurrencyPrice(oldPrice, newPrice) {if (typeof newPrice != 'undefined') {return newPrice;}return oldPrice;}data[k].price_min = updateMultiCurrencyPrice(data[k].price_min, data[k]['price_min_' + currentCurrency]);data[k].price_max = updateMultiCurrencyPrice(data[k].price_max, data[k]['price_max_' + currentCurrency]);data[k].compare_at_price_min = updateMultiCurrencyPrice(data[k].compare_at_price_min, data[k]['compare_at_price_min_' + currentCurrency]);data[k].compare_at_price_max = updateMultiCurrencyPrice(data[k].compare_at_price_max, data[k]['compare_at_price_max_' + currentCurrency]);}data[k]['price_min'] *= 100, data[k]['price_max'] *= 100, data[k]['compare_at_price_min'] *= 100, data[k]['compare_at_price_max'] *= 100;data[k]['price'] = data[k]['price_min'];data[k]['compare_at_price'] = data[k]['compare_at_price_min'];data[k]['price_varies'] = data[k]['price_min'] != data[k]['price_max'];var firstVariant = data[k]['variants'][0];if (getParam('variant') !== null && getParam('variant') != '') {var paramVariant = data[k]['variants'].filter(function(e) {return e.id == getParam('variant')});if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0]} else {var countVariants = data[k]['variants'].length;for (var i = 0; i < countVariants; i++) {if (data[k]['variants'][i].available) {firstVariant = data[k]['variants'][i];break}}}data[k]['selected_or_first_available_variant'] = firstVariant;var countVariants = data[k]['variants'].length;for (var i = 0; i < countVariants; i++) {var variantOptionArr = [];var count = 1;var variant = data[k]['variants'][i];var variantOptions = variant['merged_options'];if (Array.isArray(variantOptions)) {var countVariantOptions = variantOptions.length;for (var j = 0; j < countVariantOptions; j++) {var temp = variantOptions[j].split(':');data[k]['variants'][i]['option' + (parseInt(j) + 1)] = temp[1];data[k]['variants'][i]['option_' + temp[0]] = temp[1];variantOptionArr.push(temp[1])}data[k]['variants'][i]['options'] = variantOptionArr}data[k]['variants'][i]['compare_at_price'] = parseFloat(data[k]['variants'][i]['compare_at_price']) * 100;data[k]['variants'][i]['price'] = parseFloat(data[k]['variants'][i]['price']) * 100}data[k]['description'] = data[k]['content'] = data[k]['body_html'];if (data[k].hasOwnProperty('original_tags') && data[k]['original_tags'].length > 0) {data[k]['tags'] = data[k]['original_tags'].slice(0);}data[k]['json'] = customizeJsonProductData(data[k]);}return data;};


// Fix image url issue of swatch option
function getFilePath(fileName, ext, version) {
    var self = bcsffilter;
    var ext = typeof ext !== 'undefined' ? ext : 'png';
    var version = typeof version !== 'undefined' ? version : '1';
    var prIndex = self.fileUrl.lastIndexOf('?');
    if (prIndex > 0) {
        var filePath = self.fileUrl.substring(0, prIndex);
    } else {
        var filePath = self.fileUrl;
    }
    filePath += fileName + '.' + ext + '?v=' + version;
    return filePath;
}

BCSfFilter.prototype.getFilterData=function(eventType,errorCount){function BCSend(eventType,errorCount){var self=bcsffilter;var errorCount=typeof errorCount!=="undefined"?errorCount:0;self.showLoading();if(typeof self.buildPlaceholderProductList=="function"){self.buildPlaceholderProductList(eventType)}self.beforeGetFilterData(eventType);self.prepareRequestParams(eventType);self.queryParams["callback"]="BCSfFilterCallback";self.queryParams["event_type"]=eventType;var url=self.isSearchPage()?self.getApiUrl("search"):self.getApiUrl("filter");var script=document.createElement("script");script.type="text/javascript";var timestamp=(new Date).getTime();script.src=url+"?t="+timestamp+"&"+jQ.param(self.queryParams);script.id="bc-sf-filter-script";script.async=true;var resendAPITimer,resendAPIDuration;resendAPIDuration=2e3;script.addEventListener("error",function(e){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}if(errorCount<3){errorCount++;if(resendAPITimer){clearTimeout(resendAPITimer)}resendAPITimer=setTimeout(self.getFilterData("resend",errorCount),resendAPIDuration)}else{self.buildDefaultElements(eventType)}});document.getElementsByTagName("head")[0].appendChild(script);script.onload=function(){if(typeof document.getElementById(script.id).remove=="function"){document.getElementById(script.id).remove()}else{document.getElementById(script.id).outerHTML=""}}}this.requestFilter(BCSend,eventType,errorCount)};BCSfFilter.prototype.requestFilter=function(sendFunc,eventType,errorCount){sendFunc(eventType,errorCount)};


/* Begin patch boost-010 run 2 */
BCSfFilter.prototype.initFilter=function(){return this.isBadUrl()?void(window.location.href=window.location.pathname):(this.updateApiParams(!1),void this.getFilterData("init"))},BCSfFilter.prototype.isBadUrl=function(){try{var t=decodeURIComponent(window.location.search).split("&"),e=!1;if(t.length>0)for(var i=0;i<t.length;i++){var n=t[i],a=(n.match(/</g)||[]).length,r=(n.match(/>/g)||[]).length,o=(n.match(/alert\(/g)||[]).length,h=(n.match(/execCommand/g)||[]).length;if(a>0&&r>0||a>1||r>1||o||h){e=!0;break}}return e}catch(l){return!0}};
/* End patch boost-010 run 2 */
